import { makeStyles } from 'tss-react/mui';

interface Props {
  isOnDark?: boolean;
}

const useStyles = makeStyles<Props>({
  name: 'FAQGroup',
})(({ brandColors, spacing, breakpoints, typography }, props) => ({
  accordionRoot: {
    border: 'none',
    backgroundColor: 'transparent',
    '&.MuiPaper-root': {
      '&:before': {
        display: 'none',
      },
      backgroundColor: 'transparent',
      boxShadow: 'none',
      borderTop: `${typography.pxToRem(1)} solid ${
        props.isOnDark ? 'rgba(255, 255, 255, 0.30)' : 'rgba(0, 0, 0, 0.20)'
      }`,
      [breakpoints.up('md')]: {
        '&:last-child': {
          borderBottom: `${typography.pxToRem(1)} solid ${
            props.isOnDark ? 'rgba(255, 255, 255, 0.30)' : 'rgba(0, 0, 0, 0.20)'
          }`,
        },
      },
    },
    '&.Mui-expanded': {
      margin: 0,
    },
  },
  accordionSummaryRoot: {
    '&.MuiAccordionSummary-root': {
      '&:hover': {
        outline: 'solid',
      },
      minHeight: 'auto',
      color: props.isOnDark ? brandColors.white : brandColors.black,
      padding: spacing(1),
    },
    '&.Mui-expanded': {
      '&:hover': {
        outline: 'none',
      },
    },
  },
  accordionSummaryContent: {
    display: 'flex',
    alignItems: 'center',
    '&.MuiAccordionSummary-content': {
      margin: 0,
    },
  },
  accordionDetailsRoot: {
    '&.MuiAccordionDetails-root': {
      padding: `0 ${spacing(1)} ${spacing(1)} ${spacing(1)}`,
    },
  },
  expandIcon: {
    flexShrink: 0,
    width: typography.pxToRem(32),
    height: typography.pxToRem(32),
    backgroundColor: props.isOnDark
      ? brandColors.white
      : brandColors.primaryMain,
    borderRadius: 800,
    marginRight: spacing(0),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: props.isOnDark ? brandColors.primaryMain : brandColors.white,
  },
}));

export default useStyles;
